export default "__VITE_ASSET__e1570442__"